import { createUseStyles } from 'react-jss'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  featureColumnsContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 25px',
    gap: '24px'
  },
  featureColumnsTitle: {
    fontFamily: 'GTWalsheim',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '100%',
    textAlign: 'center'
  },
  text: {
    width: '100%',
    padding: '10px 0 !important'
  },
  image: { 
    width: '65%',
    borderRadius: '8px'
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    justifyItems: 'center',
    width: '90%'
  },
  featuresRow: {
    display: 'contents'
  },
  buttonsRow: {
    display: 'none'
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  [MediaQueries.Tablet]: {
    featureColumnsTitle: {
      fontSize: '32px'
    },
    buttonsGroup: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      justifyContent: 'center',
      boxSizing: 'border-box',
      gap: '100px',
      padding: '0px !important'
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gridAutoRows: 'auto',
      columnGap: 12,
      rowGap: 0, 
      justifyItems: 'center',
      alignItems: 'flex-start',
      width: '80%'
    },
    featuresRow: {
      display: 'contents',
      '& > *': {
        gridRow: 1
      }
    },
    text: {
      width: '85%'
    },
    buttonsRow: {
      display: 'contents',
      '& > *': {
        gridRow: 2
      }
    }
  },

  [MediaQueries.LaptopSmall]: {
    gridContainer: {
      width: '75%'
    }
  },

  [MediaQueries.LaptopLarge]: {
    gridContainer: {
      width: '70%'
    }
  }
})

export default useStyles
